import BigNumber from "bignumber.js";

export const trim = (str) => {
  if (str === undefined || str === null) {
    return "";
  }
  // eslint-disable-next-line no-param-reassign
  str = String(str);
  return str.trim();
};

export function isNullOrEmpty(val) {
  if (typeof val === "undefined") return true;
  if (typeof val === "string" && val.trim() === "") return true;
  if (val == null) return true;
  if (Number.isNaN(val)) return true;
  return false;
}

export const prototype = (obj) => {
  const objStr = Object.prototype.toString.call(obj);
  return objStr.substring(8, objStr.length - 1).toLowerCase();
};

// 乘法函数，用来得到精确的乘法结果
// 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
// 调用：accMul(arg1,arg2)
// 返回值：arg1乘以arg2的精确结果
export const accMul = (arg1, arg2) => {
  let m = 0;
  const s1 = trim(arg1);
  const s2 = trim(arg2);
  try {
    m += s1.split(".")[1].length;
  } catch (e) {
    // console.log(e);
  }
  try {
    m += s2.split(".")[1].length;
  } catch (e) {
    // console.log(e);
  }
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    10 ** m /* eslint-disable-line no-restricted-properties */
  );
};
// 精确减法
export function subTr(arg1, arg2) {
  let r1;
  let r2;
  let m;
  let n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  // eslint-disable-next-line prefer-const
  m = 10 ** Math.max(r1, r2);
  // eslint-disable-next-line prefer-const
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

export const toPercent = (num) => `${accMul(num, 100).toFixed(2)}%`;

/**
 * 分转元
 * chris的InputNumber接收null时会认为什么都没做，所以此处用undefined
 */
export const toYuan = (price) =>
  isNullOrEmpty(price) ? undefined : accMul(price, 0.01).toFixed(2);

/**
 * 元转分
 * chris的InputNumber接收null时会认为什么都没做，所以此处用undefined
 */
export const toCent = (price) =>
  isNullOrEmpty(price) ? undefined : accMul(price, 100);

/** 商品ID最大不能超过java的long型: 2的63次方(9223372036854775808) */
const LONG_INT = "9223372036854775807";
const LONG_INT_LEN = LONG_INT.length;

/**
 * @description: 判断字符串数字是否超过Java的long型
 * @param {string} val 需要校验的字符串数字
 * LONG_INT之所以不用String转成字符串是因为原本就存在精度丢失，处理之后拿到的字符串并不是想要的结果
 */
export const moreThanJavaLong = (val) => {
  const val_len = val.length;

  if (val_len > LONG_INT_LEN) {
    return true;
  }
  if (val_len < LONG_INT_LEN) {
    return false;
  }

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < LONG_INT_LEN; index++) {
    if (val[index] > LONG_INT[index]) {
      return true;
    }
  }

  return false;
};

/** 随机字符串 */
export const randomString = (len = 32) => {
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = chars.length;
  let pwd = "";

  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
};

/**
 * 精确的2个数字相加
 * @example 0.1 + 0.2 = 0.30000000000000004
 */
export const plus2 = (num1: number, num2: number) => {
  return Number(new BigNumber(num1).plus(num2));
};

/**
 * 精确的2个数字相乘
 * @example 0.1 * 0.2 = 0.020000000000000004
 */
export const multi2 = (num1: number, num2: number) => {
  return Number(new BigNumber(num1).multipliedBy(num2));
};

/**
 * 精确的2个数字相除
 */
export const divide2 = (num1: number, num2: number) => {
  return Number(new BigNumber(num1).dividedBy(num2));
};
